<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table ref="mainTable" header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="商户名称" prop="name" align="center" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="法人" prop="legal_person" align="center" width="100"></el-table-column>
      <el-table-column label="状态" prop="status_name" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.status == 1">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="关联站点" align="center">
        <template slot-scope="{ row }">
          <span>{{ getPowerSiteNames(row.powerSiteIds) }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="说明" prop="remark" align="center"></el-table-column> -->
      <el-table-column label="电话" prop="legal_phone" align="center" width="120"></el-table-column>
      <el-table-column label="联系人" prop="link_person" align="center" width="100"></el-table-column>
      <el-table-column label="联系人电话" prop="link_phone" align="center" width="120"></el-table-column>
      <el-table-column label="扫码富分账收款方" prop="SaccPayeeCode_Name" align="center" min-width="180" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column label="地址" prop="address" align="center"></el-table-column> -->
      <el-table-column label="创建时间" prop="create_date" align="center" width="160"></el-table-column>
      <el-table-column label="修改时间" prop="modify_date" align="center" width="160"></el-table-column>
      <el-table-column label="操作" width="280px" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or编辑商户：从右到左 Drawer，宽度为内容界面的 60% -->
    <el-drawer
      :title="isUpdate ? '编辑商户' : '新增商户'"
      :visible.sync="visible.editGroup"
      direction="rtl"
      :size="drawerSize"
      :wrapper-closable="false"
      @closed="onDrawerClosed"
    >
      <div class="drawer-container">
        <div class="drawer-body">
          <el-form label-position="right" label-width="150px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="商户名称" prop="name">
              <el-input placeholder="请输入商户名称" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="法人" prop="legal_person">
              <el-input placeholder="请输入法人" v-model="form.legal_person" />
            </el-form-item>
            <el-form-item label="说明" prop="remark">
              <el-input placeholder="请输入说明" v-model="form.remark" />
            </el-form-item>
            <el-form-item label="电话" prop="legal_phone">
              <el-input placeholder="请输入电话" v-model="form.legal_phone" />
            </el-form-item>
            <el-form-item label="联系人" prop="link_person">
              <el-input placeholder="请输入联系人" v-model="form.link_person" />
            </el-form-item>
            <el-form-item label="联系人电话" prop="link_phone">
              <el-input placeholder="请输入联系人电话" v-model="form.link_phone" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input placeholder="请输入地址" maxlength="40" show-word-limit v-model="form.address" />
            </el-form-item>
            <el-form-item label="是否禁用">
              <el-switch v-model="form.status" active-text="启用" inactive-text="禁用" />
            </el-form-item>
            <el-form-item label="扫码富分账收款方" prop="SaccPayeeCode">
              <el-input v-model="saccPayeeName" readonly placeholder="请选择" style="width: 100%">
                <el-button slot="append" icon="el-icon-search" @click="onOpenPayeeDialog">选择</el-button>
              </el-input>
            </el-form-item>
            <!-- 关联站点：分页搜索查询列表 -->
            <el-form-item label="关联站点">
              <div class="site-relation-panel">
                <div class="site-relation-header">
                  <el-input
                    v-model="siteFilter.site_name"
                    placeholder="请输入站点名称"
                    clearable
                    size="small"
                    style="width: 220px;margin-right:10px"
                    @clear="searchRelationSites()"
                    @keyup.enter.native="searchRelationSites()"
                  ></el-input>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="searchRelationSites()">查询</el-button>
                  <el-button size="small" type="success" icon="el-icon-plus" @click="onOpenAddSiteDialog">新增站点</el-button>
                </div>

                <el-table
                  ref="relationSiteTable"
                  :data="relationSiteList"
                  height="260"
                  border
                  size="small"
                  v-loading="relationSiteLoading"
                >
                  <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
                  <el-table-column label="站点名称" prop="name" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column label="是否投运" width="90" align="center">
                    <template slot-scope="{ row }">
                      <el-tag size="mini" type="success" v-if="isSiteOperation(row)">是</el-tag>
                      <el-tag size="mini" type="info" v-else>否</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="地址" prop="address" min-width="170" show-overflow-tooltip></el-table-column>
                  <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="{ row }">
                      <el-button type="text" class="delete-btn" @click="onDeleteRelationSite(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                <div class="site-relation-pagination">
                  <el-pagination
                    background
                    layout="sizes,total,prev,pager,next,jumper"
                    :total="relationPage.total"
                    :page-size="relationPage.limit"
                    :page-sizes="[5, 10, 50, 100]"
                    :current-page="relationPage.page"
                    @size-change="onRelationSizeChange"
                    @current-change="onRelationCurrentChange"
                  ></el-pagination>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div class="drawer-footer">
          <el-button @click="visible.editGroup = false">取消</el-button>
          <el-button type="primary" @click="onSubmit">确认</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 新增关联站点（多选 + 分页搜索所有站点） -->
    <el-dialog
      title="选择关联站点"
      :visible.sync="visible.selectSite"
      width="960px"
      append-to-body
      :close-on-click-modal="false"
      @closed="onSiteDialogClosed"
    >
      <el-form :inline="true" size="small" @keyup.enter.native="searchSelectSites()">
        <el-form-item label="站点名称">
          <el-input
            v-model="siteSelectFilter.name"
            placeholder="请输入站点名称"
            clearable
            style="width: 240px"
            @clear="searchSelectSites()"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchSelectSites()">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="siteSelectTable"
        :data="siteSelectList"
        height="380"
        border
        size="small"
        row-key="ID"
        v-loading="siteSelectLoading"
        @selection-change="onSiteSelectionChange"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
        <el-table-column label="站点名称" prop="name" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="是否投运" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="isSiteOperation(row)">是</el-tag>
            <el-tag size="mini" type="info" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="地址" prop="address" min-width="200" show-overflow-tooltip></el-table-column>
      </el-table>

      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="siteSelectPage.total"
          :page-size="siteSelectPage.limit"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="siteSelectPage.page"
          @size-change="onSiteSelectSizeChange"
          @current-change="onSiteSelectCurrentChange"
        ></el-pagination>
      </div>

      <span slot="footer">
        <el-button @click="visible.selectSite = false">取消</el-button>
        <el-button type="primary" @click="onConfirmSelectSite">确认</el-button>
      </span>
    </el-dialog>

    <!-- 选择扫码富分账收款方（单选 + 分页搜索） -->
    <el-dialog
      title="选择分账收款方"
      :visible.sync="visible.selectPayee"
      width="1100px"
      append-to-body
      :close-on-click-modal="false"
      @closed="onPayeeDialogClosed"
    >
      <el-form :inline="true" size="small" @keyup.enter.native="searchPayee()">
        <el-form-item label="关键字">
          <el-input
            v-model="payeeFilter.keyword"
            placeholder="分账收款方编号或名称"
            clearable
            style="width: 260px"
            @clear="searchPayee()"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchPayee()">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="payeeTable"
        :data="payeeTableData"
        height="380"
        border
        size="small"
        v-loading="payeeLoading"
        highlight-current-row
        @row-click="onPayeeRowClick"
      >
        <el-table-column label="" width="50" align="center">
          <template slot-scope="{ row }">
            <el-radio v-model="payeeSelectedId" :label="row.ID" @change="onPayeeRadioChange(row)">
              <span></span>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column label="分账收款方编号" prop="saccPayeeCode" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="分账收款方名称" prop="registeredName" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="分账主商户号" prop="saccMainMercCode" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="分账收款方类型" prop="saccPayeeType" width="130" align="center"></el-table-column>
        <el-table-column label="证件号码" prop="busLicNo" min-width="170" show-overflow-tooltip></el-table-column>
        <el-table-column label="结算周期（天）" prop="SettleTerm" width="120" align="center"></el-table-column>
        <el-table-column label="银行预留手机" prop="bankPhone" width="130" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="CreateTime" width="160" align="center"></el-table-column>
      </el-table>

      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="payeePage.total"
          :page-size="payeePage.limit"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="payeePage.page"
          @size-change="onPayeeSizeChange"
          @current-change="onPayeeCurrentChange"
        ></el-pagination>
      </div>

      <span slot="footer">
        <el-button @click="visible.selectPayee = false">取消</el-button>
        <el-button type="primary" @click="onConfirmPayee">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import {
  GetMerchantPageList,
  AddMerchant,
  UpdateMerchant,
  DeleteMerchant,
  GetSubMerchantSitePageList,
  AddSubMerchantSite,
  DeleteSubMerchantSite
} from "@/api/dev_data_view"
import { getPowerSiteList } from "@/api/dev_archive"
import { getSaccPayeeInfoListApi } from "@/api/finance"
import { mapGetters } from "vuex"

// 商户类型：0=主商户、1=子商户
const MERCHANT_TYPE_MAIN = 0

export default {
  name: "GroupManage",
  mixins: [pageMixin],

  data() {
    return {
      visible: {
        editGroup: false,
        selectPayee: false,
        // 关联站点选择弹窗
        selectSite: false
      },
      tableData: [],
      form: {
        name: "",
        legal_person: "",
        remark: "",
        legal_phone: "",
        link_person: "",
        link_phone: "",
        address: "",
        status: true,
        RelationMerchantNameId: "",
        SaccPayeeCode: ""
      },
      formRules: {
        name: [{ required: true, message: "请输入商户名称", trigger: "blur" }],
        address: [
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 40) {
                callback(new Error("地址长度不能超过30个字符"))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ]
      },
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "", // 商户ID
      // Drawer 宽度
      drawerSize: "60%",
      // 扫码富分账收款方：禁止输入的输入框，展示已选中的收款方名称
      saccPayeeName: "",

      /* ===== 关联站点列表（Drawer 中） ===== */
      siteFilter: {
        site_name: ""
      },
      relationSiteList: [],
      relationSiteLoading: false,
      // 新增商户时，关联站点在本地维护（商户尚未创建）
      relationSiteLocalList: [],
      // 已关联站点的ID集合
      relatedSiteIds: [],
      relationPage: {
        page: 1,
        limit: 10,
        total: 0
      },

      /* ===== 关联站点选择弹窗 ===== */
      siteSelectFilter: {
        name: ""
      },
      siteSelectList: [],
      siteSelectLoading: false,
      siteSelectSelectedRows: [],
      siteSelectSelectedIds: [],
      siteSelectPage: {
        page: 1,
        limit: 10,
        total: 0
      },

      /* ===== 扫码富分账收款方选择弹窗 ===== */
      payeeFilter: {
        keyword: ""
      },
      payeeTableData: [],
      payeeLoading: false,
      payeeSelectedId: "",
      payeeSelectedRow: null,
      payeePage: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    /* ============ 列表 ============ */
    getData() {
      this.loading = true
      GetMerchantPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null,
        type: MERCHANT_TYPE_MAIN
      })
        .then((res) => {
          this.tableData = (res && res.data) || []
          this.pageParams.total = (res && res.total) || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    onDelete(row) {
      this.$confirm("确定要删除此商户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DeleteMerchant({ ID: row.ID }).then(() => {
            this.$message.success("删除成功")
            this.getData()
          })
        })
        .catch(() => {})
    },

    fileChange(fileList, field) {
      this.form[field] = fileList
    },

    // Drawer 宽度 = 内容界面宽度的 60%
    calcDrawerSize() {
      const contentWidth = (this.$el && this.$el.clientWidth) || window.innerWidth
      return Math.max(Math.floor(contentWidth * 0.6), 360) + "px"
    },

    onAdd() {
      this.visible.editGroup = true
      this.drawerSize = this.calcDrawerSize()
      this.isUpdate = false
      this.gid = ""
      this.form = this.$options.data().form
      this.saccPayeeName = ""
      // 新增时关联站点在本地维护
      this.relationSiteLocalList = []
      this.relatedSiteIds = []
      this.siteFilter.site_name = ""
      this.relationPage.page = 1
      this.searchRelationSites()
    },

    onUpdate(row) {
      this.visible.editGroup = true
      this.drawerSize = this.calcDrawerSize()
      this.isUpdate = true
      this.gid = row.ID

      // 设置表单数据
      this.form.name = row.name
      this.form.legal_person = row.legal_person
      this.form.remark = row.remark
      this.form.legal_phone = row.legal_phone
      this.form.link_person = row.link_person
      this.form.link_phone = row.link_phone
      this.form.address = row.address
      this.form.status = row.status == 1
      this.form.RelationMerchantNameId = row.RelationMerchantNameId
      this.form.SaccPayeeCode = row.SaccPayeeCode
      // 回显已选中的扫码富分账收款方名称
      this.saccPayeeName = row.SaccPayeeCode_Name || ""

      // 查询该商户已关联的站点列表
      this.siteFilter.site_name = ""
      this.relationPage.page = 1
      this.relationSiteLocalList = []
      this.searchRelationSites()
    },

    onDrawerClosed() {
      this.form = this.$options.data().form
      this.saccPayeeName = ""
      this.gid = ""
      this.relationSiteList = []
      this.relationSiteLocalList = []
      this.relatedSiteIds = []
      this.relationPage.page = 1
      this.relationPage.total = 0
      this.siteFilter.site_name = ""
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (!valid) return
        const loading = this.$loading()
        const reqData = {
          name: this.form.name,
          legal_person: this.form.legal_person,
          remark: this.form.remark,
          legal_phone: this.form.legal_phone,
          link_person: this.form.link_person,
          link_phone: this.form.link_phone,
          address: this.form.address,
          status: this.form.status ? 1 : 0,
          RelationMerchantNameId: this.form.RelationMerchantNameId,
          SaccPayeeCode: this.form.SaccPayeeCode
        }

        if (this.isUpdate) {
          reqData.ID = this.gid
          UpdateMerchant(reqData)
            .then(() => {
              this.$message.success("修改成功")
              this.visible.editGroup = false
              this.getData()
            })
            .finally(() => {
              loading.close()
            })
        } else {
          // 新增商户：商户尚未创建，关联站点随表单一起提交，由服务端建立关联关系
          reqData.powerSiteIds = this.relationSiteLocalList.map((item) => this.getRowSiteId(item))
          AddMerchant(reqData)
            .then(() => {
              this.$message.success("新增成功")
              this.visible.editGroup = false
              this.getData()
            })
            .finally(() => {
              loading.close()
            })
        }
      })
    },

    /* ============ 关联站点列表（Drawer 中） ============ */
    // 关联站点行的站点ID（兼容不同字段名）
    getRowSiteId(row) {
      if (!row) return ""
      return row.site_id || row.power_site_id || row.ID || ""
    },

    isSiteOperation(row) {
      if (!row) return false
      return row.is_operation === true || row.is_operation === 1 || row.is_operation === "true" || row.is_operation === "是"
    },

    // 查询商户关联的站点列表
    // 新增商户时商户尚未创建，关联站点数据在本地维护
    searchRelationSites(resetPage = true) {
      if (resetPage) this.relationPage.page = 1

      if (!this.isUpdate || !this.gid) {
        const keyword = (this.siteFilter.site_name || "").trim()
        const filtered = keyword
          ? this.relationSiteLocalList.filter((item) => (item.name || "").indexOf(keyword) > -1)
          : this.relationSiteLocalList
        this.relationPage.total = filtered.length
        const start = (this.relationPage.page - 1) * this.relationPage.limit
        this.relationSiteList = filtered.slice(start, start + this.relationPage.limit)
        return
      }

      this.relationSiteLoading = true
      GetSubMerchantSitePageList({
        merchant_id: this.gid,
        site_name: this.siteFilter.site_name || null,
        page: this.relationPage.page,
        pagesize: this.relationPage.limit,
        type: MERCHANT_TYPE_MAIN
      })
        .then((res) => {
          this.relationSiteList = (res && res.data) || []
          this.relationPage.total = (res && res.total) || 0
          this.$nextTick(() => {
            if (this.$refs.relationSiteTable) {
              this.$refs.relationSiteTable.doLayout()
            }
          })
        })
        .catch(() => {})
        .finally(() => {
          this.relationSiteLoading = false
        })
    },

    onRelationSizeChange(val) {
      this.relationPage.limit = val
      this.searchRelationSites()
    },

    onRelationCurrentChange(val) {
      this.relationPage.page = val
      this.searchRelationSites(false)
    },

    // 删除关联站点：编辑时请求服务端，新增时仅本地删除
    onDeleteRelationSite(row) {
      this.$confirm(`确定要删除站点「${row.name}」的关联吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.isUpdate && this.gid) {
            const loading = this.$loading()
            DeleteSubMerchantSite({
              ID: row.ID,
              merchant_id: this.gid,
              site_id: this.getRowSiteId(row),
              type: MERCHANT_TYPE_MAIN
            })
              .then(() => {
                this.$message.success("删除成功")
                this.searchRelationSites()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            this.relationSiteLocalList = this.relationSiteLocalList.filter(
              (item) => this.getRowSiteId(item) !== this.getRowSiteId(row)
            )
            this.searchRelationSites()
            this.$message.success("删除成功")
          }
        })
        .catch(() => {})
    },

    /* ============ 关联站点选择弹窗 ============ */
    onOpenAddSiteDialog() {
      this.visible.selectSite = true
      this.siteSelectFilter.name = ""
      this.siteSelectPage.page = 1
      this.siteSelectPage.total = 0
      this.siteSelectList = []
      this.siteSelectSelectedRows = []
      this.siteSelectSelectedIds = []
      // 先取已关联站点集合（用于默认勾选），再查询所有站点
      this.loadRelatedSiteIds().then(() => {
        this.searchSelectSites()
      })
    },

    // 已关联的站点ID集合
    loadRelatedSiteIds() {
      if (!this.isUpdate || !this.gid) {
        this.relatedSiteIds = this.relationSiteLocalList.map((item) => this.getRowSiteId(item))
        return Promise.resolve()
      }
      return GetSubMerchantSitePageList({
        merchant_id: this.gid,
        page: 1,
        pagesize: 100000,
        type: MERCHANT_TYPE_MAIN
      })
        .then((res) => {
          const list = (res && res.data) || []
          this.relatedSiteIds = list.map((item) => this.getRowSiteId(item))
        })
        .catch(() => {
          this.relatedSiteIds = []
        })
    },

    // 分页搜索所有站点
    searchSelectSites(resetPage = true) {
      if (resetPage) this.siteSelectPage.page = 1
      this.siteSelectLoading = true
      getPowerSiteList({
        page: this.siteSelectPage.page,
        pagesize: this.siteSelectPage.limit,
        name: this.siteSelectFilter.name || null
      })
        .then((res) => {
          this.siteSelectList = (res && res.data) || []
          this.siteSelectPage.total = (res && res.total) || 0
          // 已关联的站点默认勾选
          this.$nextTick(() => {
            this.syncSiteSelectedState()
          })
        })
        .catch(() => {})
        .finally(() => {
          this.siteSelectLoading = false
        })
    },

    // 已关联站点默认勾选（同时保留用户在当前弹窗中手动勾选的站点）
    syncSiteSelectedState() {
      const table = this.$refs.siteSelectTable
      if (!table) return
      this.siteSelectList.forEach((row) => {
        const siteId = this.getRowSiteId(row)
        const checked = this.relatedSiteIds.indexOf(siteId) > -1 || this.siteSelectSelectedIds.indexOf(siteId) > -1
        table.toggleRowSelection(row, checked)
      })
    },

    onSiteSelectSizeChange(val) {
      this.siteSelectPage.limit = val
      this.searchSelectSites()
    },

    onSiteSelectCurrentChange(val) {
      this.siteSelectPage.page = val
      this.searchSelectSites(false)
    },

    onSiteSelectionChange(rows) {
      this.siteSelectSelectedRows = rows || []
      this.siteSelectSelectedIds = this.siteSelectSelectedRows.map((item) => this.getRowSiteId(item))
    },

    // 确认选择关联站点
    onConfirmSelectSite() {
      const selected = this.siteSelectSelectedRows || []
      if (!selected.length) {
        this.$message.warning("请先选择站点")
        return
      }
      // 仅提交新勾选（未关联）的站点
      const newSites = selected.filter((row) => this.relatedSiteIds.indexOf(this.getRowSiteId(row)) === -1)
      if (!newSites.length) {
        this.$message.warning("所选站点已关联，请勿重复添加")
        return
      }

      if (this.isUpdate && this.gid) {
        // 编辑商户：直接提交服务端，成功后刷新关联站点列表
        const loading = this.$loading()
        AddSubMerchantSite({
          merchant_id: this.gid,
          siteIds: JSON.stringify(newSites.map((row) => this.getRowSiteId(row))),
          type: MERCHANT_TYPE_MAIN
        })
          .then(() => {
            this.$message.success("添加成功")
            this.relatedSiteIds = this.relatedSiteIds.concat(newSites.map((row) => this.getRowSiteId(row)))
            this.visible.selectSite = false
            this.searchRelationSites()
          })
          .finally(() => {
            loading.close()
          })
      } else {
        // 新增商户：商户尚未创建，先把选中的站点展示在 Drawer 的关联站点列表中
        newSites.forEach((row) => {
          if (!this.relationSiteLocalList.some((item) => this.getRowSiteId(item) === this.getRowSiteId(row))) {
            this.relationSiteLocalList.push({ ...row })
          }
        })
        this.relatedSiteIds = this.relationSiteLocalList.map((item) => this.getRowSiteId(item))
        this.visible.selectSite = false
        this.searchRelationSites()
        this.$message.success("已添加")
      }
    },

    onSiteDialogClosed() {
      this.siteSelectSelectedRows = []
      this.siteSelectSelectedIds = []
      if (this.$refs.siteSelectTable) {
        this.$refs.siteSelectTable.clearSelection()
      }
    },

    /* ============ 扫码富分账收款方选择 ============ */
    onOpenPayeeDialog() {
      this.visible.selectPayee = true
      this.payeeFilter.keyword = ""
      this.payeePage.page = 1
      this.payeeSelectedId = ""
      this.payeeSelectedRow = null
      this.payeeTableData = []
      this.searchPayee()
    },

    searchPayee(resetPage = true) {
      if (resetPage) this.payeePage.page = 1
      this.payeeLoading = true
      getSaccPayeeInfoListApi({
        page: this.payeePage.page,
        pagesize: this.payeePage.limit,
        keyword: this.payeeFilter.keyword || null
      })
        .then((res) => {
          this.payeeTableData = (res && res.data) || []
          this.payeePage.total = (res && res.total && res.total.Value) || this.payeeTableData.length
          this.syncPayeeSelection()
        })
        .catch(() => {})
        .finally(() => {
          this.payeeLoading = false
        })
    },

    // 弹窗内已选中的数据出现在当前页时，同步回选中行
    syncPayeeSelection() {
      if (!this.payeeSelectedId) return
      const row = this.payeeTableData.find((item) => item.ID === this.payeeSelectedId)
      if (row) {
        this.payeeSelectedRow = row
      }
    },

    onPayeeSizeChange(val) {
      this.payeePage.limit = val
      this.searchPayee()
    },

    onPayeeCurrentChange(val) {
      this.payeePage.page = val
      this.searchPayee(false)
    },

    onPayeeRadioChange(row) {
      this.payeeSelectedRow = row
    },

    onPayeeRowClick(row) {
      this.payeeSelectedId = row.ID
      this.payeeSelectedRow = row
    },

    // 确认选择：名称回填输入框，ID 赋值给表单
    onConfirmPayee() {
      if (!this.payeeSelectedRow) {
        this.$message.warning("请先选择一个分账收款方")
        return
      }
      this.form.RelationMerchantNameId = this.payeeSelectedRow.ID
      this.form.SaccPayeeCode = this.payeeSelectedRow.saccPayeeCode
      this.saccPayeeName = this.payeeSelectedRow.registeredName || ""
      this.visible.selectPayee = false
    },

    onPayeeDialogClosed() {
      this.payeeSelectedId = ""
      this.payeeSelectedRow = null
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.input-small {
  width: 200px;
}

.ml-10 {
  margin-left: 10px;
}

/* ============ 新增/编辑 Drawer ============ */
.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px 0;
}

.drawer-footer {
  flex-shrink: 0;
  padding: 12px 24px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

::v-deep .el-drawer__body {
  overflow: hidden;
}

/* ============ 关联站点 ============ */
.site-relation-panel {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
  background-color: #fff;
  box-sizing: border-box;
}

.site-relation-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.site-relation-header .el-button + .el-button {
  margin-left: 10px;
}

.site-relation-pagination {
  margin-top: 10px;
  text-align: right;
}

.delete-btn {
  color: #f56c6c;
}

/* 关联站点列表内的分页更紧凑 */
.site-relation-pagination ::v-deep .el-pagination {
  padding: 0;
}
</style>
